export const colors = {
    greyLight: '#E2E2E2',
    greyMedium: '#A3A3A3',
    greyDark: '#666666',
    black: '#000000',
    white: '#FFFFFF',
};
